import { createContext } from 'react';
import Bed from '../rounding/Model/Bed';
import BedAssignment from '../rounding/Model/BedAssignment';

export type CensusContextType = {
  openAddBedModal: (bed: Bed | null) => void;
  openTransferBedModal: (bed: Bed | null) => void;
  closeAddBedModal: () => void;
  closeTransferBedModal: () => void;
  onSaveEntity: (id: number, bedAssignment: BedAssignment) => void;
};

export const CensusContext = createContext<CensusContextType>({
  openAddBedModal: () => {},
  openTransferBedModal: () => {},
  closeAddBedModal: () => {},
  closeTransferBedModal: () => {},
  onSaveEntity: () => {},
});

export const CensusProvider = CensusContext.Provider;